import type { IconSvgObject } from './types';

const PulseRectangle01Icon: IconSvgObject = [
  ["path", { d: "M5.5 12H7.5L9 9.5L10.5 14L12.5 8L14.5 16L16.5 12H18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.4998 4.50023L21.498 19.5002C21.4979 20.6047 20.6025 21.5 19.498 21.5H4.50996C3.40585 21.5 2.51061 20.6053 2.50996 19.5012L2.50117 4.50117C2.50053 3.39614 3.39615 2.5 4.50117 2.5H19.4998C20.6044 2.5 21.4999 3.39557 21.4998 4.50023Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default PulseRectangle01Icon;
